import { Injectable, signal } from '@angular/core';
import { GetCapacityReportQuery } from '@libs/services/graphql/generated/ala-backend.service';
import { Mutable } from '@libs/services/graphql/utilities/to-mutable';
import { Observable, Subject } from 'rxjs';

export type DataEntrySubmissionState = {
  success: boolean;
  error?: string;
  context?: unknown;
};

type CapacityReportType = Mutable<GetCapacityReportQuery['capacityReport']>;

@Injectable({
  providedIn: 'root',
})
export class DataEntryStateService {
  private readonly editorClosedSubject = new Subject<void>();

  readonly editorClosed$: Observable<void> =
    this.editorClosedSubject.asObservable();

  timeoutInterval: number | undefined;

  readonly currentCapacityReport = signal<CapacityReportType | undefined>(
    undefined
  );

  readonly submissionResult = signal<DataEntrySubmissionState | undefined>(
    undefined
  );

  notifyEditorClosed() {
    this.editorClosedSubject.next();
  }

  loadConfig(interval: number) {
    this.timeoutInterval = interval;
  }
}
